module.exports = __webpack_public_path__ + "img/vip-banner-bg.adeaa41f.png";